import React from 'react';
import PropTypes from 'prop-types';
import ListCategories from 'components/ListCategories/ListCategories';

const NotificationSettingView = (props) => {
  const { formatText, configuration, environmentConfig } = props;

  return (
    <div className="historic-view col-xs-12 col-md-12">
      <ListCategories
        formatText={formatText}
        showProducts={false}
        environmentConfig={environmentConfig}
        configuration={configuration}
      />
    </div>
  );
};

NotificationSettingView.propTypes = {
  configuration: PropTypes.obj,
  formatText: PropTypes.func.isRequired,
  environmentConfig: PropTypes.string.isRequired,
};

NotificationSettingView.defaultProps = {
  configuration: {},
};

export default NotificationSettingView;
